

































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import PilihanChip from "./PilihanChip.vue";
import RekamAsuhanHemodialisisSvc from "@/services/RekamAsuhanHemodialisis";
import { appModule } from "@/store/modules/app";
import { maskTekananDarah, validasiTekananDarah } from "@/utils/tekananDarah";
import { ATURAN } from "./aturanIsian";
import {
  FaseHemodialisis,
  KatalogRah,
  MonitoringRah,
  MonitoringRahInput,
  RekamAsuhanHemodialisis
} from "@/types/rekam_asuhan_hemodialisis";

const KOLOM_ANGKA: Array<keyof MonitoringRahInput> = [
  "qb",
  "uf_rate",
  "nadi",
  "suhu",
  "respirasi",
  "intake_nacl",
  "intake_dextrose",
  "intake_makan_minum",
  "intake_lain",
  "uf_tercapai"
];

const LABEL_INTAKE: Array<[keyof MonitoringRahInput, string]> = [
  ["intake_nacl", "NaCl"],
  ["intake_dextrose", "Dex 40%"],
  ["intake_makan_minum", "Makan/minum"],
  ["intake_lain", "Lain"]
];

function jamSekarang(): string {
  const now = new Date();

  return `${String(now.getHours()).padStart(2, "0")}:${String(
    now.getMinutes()
  ).padStart(2, "0")}`;
}

function toNumberOrNull(v: unknown): number | null {
  if (v === null || v === undefined || v === "") return null;
  const n = Number(v);

  return isNaN(n) ? null : n;
}

function formKosong(fase: FaseHemodialisis): MonitoringRahInput {
  return {
    fase,
    jam: jamSekarang(),
    qb: null,
    uf_rate: null,
    tekanan_darah: null,
    nadi: null,
    suhu: null,
    respirasi: null,
    intake_nacl: null,
    intake_dextrose: null,
    intake_makan_minum: null,
    intake_lain: null,
    uf_tercapai: null,
    keterangan: null
  };
}

@Component({
  components: { PilihanChip }
})
export default class MonitoringHemodialisisTable extends Vue {
  @Prop({ type: Object, required: true }) readonly doc!: RekamAsuhanHemodialisis;
  @Prop({ type: Object, required: true }) readonly katalog!: KatalogRah;
  @Prop({ type: String, default: "" }) readonly blockReason!: string;
  @Prop({ default: null }) readonly userId!: number | null;

  dialog = false;
  valid = false;
  saving = false;
  editingId: number | null = null;
  deletingId: number | null = null;
  form: MonitoringRahInput = formKosong("pre");

  warnaFase: Record<FaseHemodialisis, string> = {
    pre: "blue",
    intra: "teal",
    post: "deep-purple"
  };

  headers = [
    { text: "Observasi", value: "fase", width: "90px" },
    { text: "Jam", value: "jam", width: "60px" },
    { text: "QB", value: "qb" },
    { text: "UF Rate", value: "uf_rate" },
    { text: "TD", value: "tekanan_darah" },
    { text: "Nadi", value: "nadi" },
    { text: "Suhu", value: "suhu" },
    { text: "Resp", value: "respirasi" },
    { text: "Intake (ml)", value: "intake" },
    { text: "UF Tercapai", value: "uf_tercapai" },
    { text: "Keterangan", value: "keterangan" },
    { text: "Petugas", value: "user_nama" },
    { text: "", value: "actions", width: "80px" }
  ];

  validasiTd = validasiTekananDarah;

  rules = {
    required: (v: unknown) =>
      (v !== null && v !== undefined && String(v).trim() !== "") ||
      "Wajib diisi"
  };

  ATURAN = ATURAN;

  onTdInput(val: string) {
    const bersih = maskTekananDarah(val || "", this.form.tekanan_darah || "");
    this.form.tekanan_darah = bersih;

    if (bersih !== val) {
      const field = this.$refs.tdRef as { lazyValue?: string };
      if (field) field.lazyValue = bersih;
    }
  }

  labelFase(fase: string): string {
    const opsi = this.katalog.fase.find(it => it.value === fase);

    return opsi ? opsi.text : fase;
  }

  ringkasIntake(item: MonitoringRah): string[] {
    return LABEL_INTAKE.filter(([kunci]) => item[kunci] !== null).map(
      ([kunci, label]) => `${label} ${item[kunci]}`
    );
  }

  rowBlockReason(item: MonitoringRah): string {
    if (this.blockReason) return this.blockReason;
    if (item.user_id !== this.userId) {
      return "Observasi hanya dapat diubah oleh petugas yang mencatatnya.";
    }

    return "";
  }

  bukaTambah() {
    if (this.blockReason) return;

    const rows = this.doc.monitoring;
    const adaPre = rows.some(it => it.fase === "pre");
    this.form = formKosong(adaPre ? "intra" : "pre");
    const terakhir = rows.length ? rows[rows.length - 1] : null;
    if (terakhir) {
      this.form.qb = terakhir.qb;
      this.form.uf_rate = terakhir.uf_rate;
    } else {
      this.form.qb = this.doc.instruksi.qb;
    }
    this.editingId = null;
    this.dialog = true;
    this.$nextTick(() => this.resetValidation());
  }

  bukaUbah(item: MonitoringRah) {
    if (this.rowBlockReason(item)) return;

    const form = formKosong(item.fase);
    (Object.keys(form) as Array<keyof MonitoringRahInput>).forEach(kunci => {
      (form as unknown as Record<string, unknown>)[kunci] = item[kunci];
    });
    this.form = form;
    this.editingId = item.id;
    this.dialog = true;
  }

  tutup() {
    this.dialog = false;
    this.editingId = null;
  }

  resetValidation() {
    const ref = this.$refs.formRef as Vue & { resetValidation: () => void };
    if (ref) ref.resetValidation();
  }

  payload(): MonitoringRahInput {
    const data = { ...this.form };
    KOLOM_ANGKA.forEach(kunci => {
      (data as unknown as Record<string, unknown>)[kunci] = toNumberOrNull(
        data[kunci]
      );
    });
    data.tekanan_darah = data.tekanan_darah ? data.tekanan_darah.trim() : null;
    data.keterangan = data.keterangan ? data.keterangan.trim() : null;

    return data;
  }

  async simpan() {
    if (!this.valid || !this.form.fase) return;

    this.saving = true;
    try {
      const doc = this.editingId
        ? await RekamAsuhanHemodialisisSvc.updateMonitoring(
            this.doc.id,
            this.editingId,
            this.payload()
          )
        : await RekamAsuhanHemodialisisSvc.storeMonitoring(
            this.doc.id,
            this.payload()
          );
      this.$emit("updated", doc);
      this.tutup();
      appModule.NoticeDelay("Observasi monitoring berhasil disimpan");
    } finally {
      this.saving = false;
    }
  }

  async hapus(item: MonitoringRah) {
    if (this.rowBlockReason(item)) return;
    if (!confirm(`Hapus observasi ${this.labelFase(item.fase)} jam ${item.jam}?`)) return;

    this.deletingId = item.id;
    try {
      const doc = await RekamAsuhanHemodialisisSvc.deleteMonitoring(
        this.doc.id,
        item.id
      );
      this.$emit("updated", doc);
      appModule.NoticeDelay("Observasi monitoring berhasil dihapus");
    } finally {
      this.deletingId = null;
    }
  }
}
